
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Room from "@/domain/restaurant/Room";
import { VuetifyForm } from "@/plugins/vuetify";
import RemoteServices from "@/services/RemoteServices";
import FormService from "@/services/FormService";
import Restaurant from "@/domain/restaurant/Restaurant";

@Component
export default class RoomPropertiesForm extends Vue {
  @Prop({
    default: function() {
      return new Room();
    }
  })
  room!: Room;

  roomCopy = Room.copy(this.room);

  formValid = false;

  requiredRule = [FormService.requiredStringRule];

  @Prop({
    default: function() {
      return new Restaurant();
    }
  })
  restaurant!: Restaurant;

  loading = false;

  get hasChanges() {
    return Room.haveDifferences(this.room, this.roomCopy);
  }

  get createNewRoom() {
    return this.room.roomId == null;
  }

  get roomForm() {
    return this.$refs.roomForm as VuetifyForm;
  }

  addRoom() {
    this.$emit("new-room", this.roomCopy);
    this.loading = false;
  }

  @Watch("room")
  resetFields() {
    this.roomCopy = Room.copy(this.room);
    this.loading = false;
  }

  async createRoom() {
    await this.roomForm.validate();
    if (this.formValid) {
      this.loading = true;
      try {
        this.roomCopy = await RemoteServices.createRoom(
          Room.getLightweightCopyToSend(this.room, this.roomCopy),
          await this.$store.getters.getSelectedRestaurant.restaurantId
        );
        this.$store.dispatch("success", this.$t("room.create.success"));
        this.addRoom();
      } catch (error) {
        this.$store.dispatch("error", error.message);
      }
      this.loading = false;
    }
  }

  async updateRoom() {
    await this.roomForm.validate();
    if (this.formValid) {
      this.loading = true;
      try {
        this.roomCopy = await RemoteServices.updateRoomProperties(
          Room.getLightweightCopyToSend(this.room, this.roomCopy)
        );
        this.$store.dispatch("success", this.$t("room.edit.success"));
        this.updateTargetRoom();
      } catch (error) {
        this.$store.dispatch("error", error.message);
      }
      this.loading = false;
    }
  }

  updateTargetRoom() {
    Room.update(this.room, this.roomCopy);
    this.$emit("update-room");
    this.loading = false;
  }

  get allPossibleTimesInRestaurant(): string[] {
    return Restaurant.getAllPossibleTimesInRestaurant(this.restaurant);
  }
}
